const highlightColor = 'rgb(183, 234, 255)';
const highlightColorKeyword = 'rgba(255, 255, 0, 0.7)';

export const formatHighlightTextWithDateAndKeyword = (text: string, keyword: string = ''): string => {
    const imgPlaceholders: string[] = [];
    const imgRegex = /<img[^>]*>/gi;
    let processedText = text.replace(imgRegex, (match: string) => {
        const placeholder = `__IMG_PLACEHOLDER_${imgPlaceholders.length}__`;
        imgPlaceholders.push(match);
        return placeholder;
    });
    const datePatternParts = [
        '(?:19|20|21)\\d{2}\\s*년\\s*(?:1[0-2]|0?[1-9])\\s*월\\s*(?:3[01]|[12]\\d|0?[1-9])\\s*일',
        '(?:19|20|21)\\d{2}\\s*년\\s*(?:1[0-2]|0?[1-9])\\s*월',
        '(?:19|20|21)\\d{2}\\s*년',
        '(?:1[0-2]|0?[1-9])\\s*월\\s*(?:3[01]|[12]\\d|0?[1-9])\\s*일',
        '(?:지난|오는|다음|이번)\\s*(?:3[01]|[12]\\d|0?[1-9])\\s*일',
        '(?:지난|오는|다음|이번)\\s*(?:1[0-2]|0?[1-9])\\s*월',
        '(?:1[0-2]|0?[1-9])\\s*월',
        '(?:3[01]|[12]\\d|0?[1-9])\\s*일',
    ];
    const datePattern = `(?:${datePatternParts.join('|')})`;
    const dateRegex = new RegExp(datePattern, 'gi');
    const keywordRegex = new RegExp(keyword, 'gi');
    processedText = processedText.replace(dateRegex, (match: string) => {
        return `<span style="background-color: ${highlightColor};" data-mce-style="background-color: ${highlightColor};">${match}</span>`;
    }).replace(keywordRegex, (match: string) => {
        return `<span style="background-color: ${highlightColorKeyword};" data-mce-style="background-color: ${highlightColorKeyword};">${match}</span>`;
    });

    imgPlaceholders.forEach((imgTag: string, index: number) => {
        processedText = processedText.replace(`__IMG_PLACEHOLDER_${index}__`, imgTag);
    });
    return processedText;
};

export const formatClearHighlightTextWithDateAndKeyword = (text: string = ''): string => {
    return text.replaceAll(/background-color: rgb\(183, 234, 255\);/g, '').replaceAll(/background-color: rgba\(255, 255, 0, 0.7\);/g, '');
};

export const formatHighlightTextTravel = (text: string = '') => {
    const _keywords = ['대화 맥락(요약)', '사용자 입력 데이터', '키워드:', '현재 날짜:', '날씨 정보:', '추천 장소 데이터(JSON):', '키워드:', '현재 날짜 타이틀:', '추천 장소 데이터', '날씨 정보', '- Place:'];
    _keywords.forEach((keyword: string) => {
        const escapedKeyword = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        text = text.replaceAll(new RegExp(escapedKeyword, 'gi'), `<span style="background-color: rgba(255, 255, 0, 0.7);">${keyword}</span>`);
    });
    return text;
};